export const BUTTON_MD = 'h-10 gap-[7px] px-4 has-[>svg]:px-4 text-[14px] font-medium';
export const BUTTON_SM = 'h-8 gap-[7px] px-3 has-[>svg]:px-3 text-[13px] font-medium';
export const TIGHT = 'px-2 has-[>svg]:px-2';
export const OUTLINE = 'border-border-default bg-white text-stone-950';
export const GHOST = 'text-foreground-muted';

export const BELOW_TOP_BAR = 'sticky top-13 h-[calc(100vh-52px)]';
export const FILL_BELOW_TOP_BAR = 'min-h-[calc(100vh-52px)]';

export const CARD = 'rounded-2xl border border-stone-200 bg-white';
export type Toggle = 'on' | 'off';
export const toggleOf = (on: boolean): Toggle => (on ? 'on' : 'off');

export const TAB_BUTTON =
  '-mb-px flex h-11 items-center gap-2 whitespace-nowrap border-b-2 px-3 text-[14px] font-medium';
export const TAB_STATE: Record<Toggle, string> = {
  on: 'border-neutral-950 text-neutral-950',
  off: 'border-transparent text-stone-500 hover:text-neutral-950',
};
export const TAB_COUNT = 'rounded-full px-[7px] py-px text-caption-regular/4 font-medium';
export const TAB_COUNT_STATE: Record<Toggle, string> = {
  on: 'bg-neutral-950 text-white',
  off: 'bg-beige-200 text-stone-500',
};

export const BULK_OUTLINE =
  'border-zinc-700 bg-transparent text-white hover:bg-zinc-800 hover:text-white';
export const BULK_PRIMARY = 'bg-white text-neutral-950 hover:bg-white/90';

export const PERSONA_GRID = 'grid grid-cols-[repeat(auto-fill,minmax(336px,1fr))] gap-4';
export const RESULT_GRID = 'grid grid-cols-[repeat(auto-fill,minmax(420px,1fr))] gap-[14px]';
export const EDITOR_COLUMN = 'w-full max-w-[820px]';
export const SECTION_TITLE = 'text-[15px] font-medium leading-5 text-stone-950';
export const HINT = 'text-[12px] leading-4 text-foreground-muted';
export const FIELD =
  'w-full rounded-[6px] border border-border-default bg-white text-[14px] text-stone-950 shadow-none outline-none placeholder:text-foreground-subtle';
export const EMBEDDED_FIELD =
  'h-auto min-h-0 rounded-none border-0 bg-transparent p-0 shadow-none focus-visible:ring-0 dark:bg-transparent';
export const TAG =
  'inline-flex h-5 items-center whitespace-nowrap rounded-full bg-beige-200 px-2 text-[12px] font-medium text-foreground-muted';
export const AMBER_BADGE =
  'inline-flex h-5 items-center gap-1 whitespace-nowrap rounded-full bg-discovery-warning-bg px-2.5 text-[12px] font-medium text-foreground-warning-default';
